var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutoCheckoutFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1101_14594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.27575 6.66699H14.7249C14.9652 6.66696 15.2027 6.7189 15.4211 6.81924C15.6394 6.91958 15.8335 7.06596 15.99 7.24833C16.1465 7.4307 16.2617 7.64475 16.3277 7.87581C16.3937 8.10687 16.4089 8.34948 16.3724 8.58699L15.3266 15.3803C15.2358 15.9707 14.9366 16.509 14.4832 16.8979C14.0299 17.2868 13.4522 17.5005 12.8549 17.5003H7.14492C6.54775 17.5003 5.97032 17.2865 5.51711 16.8977C5.0639 16.5088 4.76486 15.9706 4.67409 15.3803L3.62825 8.58699C3.59173 8.34948 3.60699 8.10687 3.67301 7.87581C3.73902 7.64475 3.85422 7.4307 4.01071 7.24833C4.16719 7.06596 4.36127 6.91958 4.57962 6.81924C4.79798 6.7189 5.03545 6.66696 5.27575 6.66699Z",
    stroke: "#1D4B3E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.16667V5C7.5 4.33696 7.76339 3.70107 8.23223 3.23223C8.70107 2.76339 9.33696 2.5 10 2.5C10.663 2.5 11.2989 2.76339 11.7678 3.23223C12.2366 3.70107 12.5 4.33696 12.5 5V9.16667",
    stroke: "#1D4B3E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1101_14594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoCheckoutFlow);
export default __webpack_public_path__ + "static/media/auto_checkout_flow.222d71be.svg";
export { ForwardRef as ReactComponent };